import { render, staticRenderFns } from "./RfDataNotiPop.vue?vue&type=template&id=e9b089c2"
import script from "./RfDataNotiPop.vue?vue&type=script&lang=js"
export * from "./RfDataNotiPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9b089c2')) {
      api.createRecord('e9b089c2', component.options)
    } else {
      api.reload('e9b089c2', component.options)
    }
    module.hot.accept("./RfDataNotiPop.vue?vue&type=template&id=e9b089c2", function () {
      api.rerender('e9b089c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/RfDataNotiPop.vue"
export default component.exports